import { gql, useQuery } from '@apollo/client';
import {
  GetRolesQuery,
  GetRolesQueryVariables,
} from '../../../__generated__/queries-auth';

export const GET_ROLES = gql`
  query GetRoles(
    $first: UnsignedInt!
    $skip: UnsignedInt
    $where: RoleFilterInput
  ) {
    roles(first: $first, skip: $skip, where: $where) {
      id
      slug
    }
  }
`;

export const useRoles = (variables: GetRolesQueryVariables, skip?: boolean) =>
  useQuery<GetRolesQuery, GetRolesQueryVariables>(GET_ROLES, {
    variables,
    skip,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
